import React from "react";

import AccountBanner from "components/AccountBanner";
import MUIDataTable from "mui-datatables";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";

import { getRequest, postRequest } from "sharedUtils/httpUtils";
import ActionButton from "components/ActionButton";

// {sectorId, name, accepted}
class Sectors extends React.Component {
    state = {
        sectors: [],
        testSector: null,
        sectorsLoading: false,
        sectorCreateInput: "",
        searchText: "",
        updateError: false,
        updateErrorMessage: "There was an error updating this sector.",
        newSectorExists: "NEW SECTOR ALREADY EXISTS",
        updatingSectorIds: [],
        noAcceptedDisplayed: false,
        SectorsTable: {
            title: "Sectors",
            options: {
                selectableRows: "multiple",
                rowsPerPage: 100,
                //sortOrder: {
                //    name: "sectorId",
                //    direction: "asc",
                //},
            },
            getTheme: () =>
                createTheme({
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                "&:nth-child(odd)": {
                                    backgroundColor: "#F9F9F9",
                                },
                                cursor: "pointer",
                            },
                        },
                    },
                }),
        },
    };

    async componentDidMount() {
        let sectors = await this.fetchSectors();
        this.setState({ sectors });
    }

    addSector = async (sectorName) => {
        if (sectorName.length > 0) {
            var addedSector = await postRequest(
                `api/Sector/CreateSector?text=${encodeURIComponent(sectorName)}`
            );

            let sectors = [ addedSector, ...this.state.sectors ];
            this.setState({ sectors, sectorCreateInput: "" });
        }
    };

    handleSectorInput = (e) => {
        const input = e.target.value;
        let found = this.checkIfSectorExists(input);
        this.setState({
            sectorCreateInput: input,
            searchText: found ? input : ""
        });
    };

    updateSector = async (sector) => {
        this.setState((prev) => ({
            updatingSectorIds: [...prev.updatingSectorIds, sector.sectorId],
            updateError: false,
        }));

        let model = {
            sectorId: sector.sectorId,
            name: sector.name,
            status: sector.accepted ? 0 : 1,
        };

        try {
            const update = await postRequest(
                `api/Sector/UpdateSector`, model);
            console.log("returned sector from update: ", update);
            if (update) {
                const sectors = await this.fetchSectors();
                this.setState({ sectors });
            } else {
                this.setState({ updateError: true });
            }
        } catch {
            this.setState({ updateError: true });
        } finally {
            this.setState((prev) => ({
                updatingSectorIds: prev.updatingSectorIds.filter(
                    (id) => id !== sector.sectorId
                ),
            }));
        }
    };

    checkIfSectorExists = (sectorName) => {
        let existing = this.state.sectors.filter(
            (sector) =>
                sector.name.toLowerCase() ===
                sectorName.trim().toLowerCase()
        );
        return existing.length > 0;
    };

    fetchSectors = async () => {
        this.setState({ sectorsLoading: true });
        let sectors = await getRequest(`api/Sector/GetSectors?getAll=true`);
        this.setState({ sectorsLoading: false });
        return sectors;
    };

    displaySectors = () => {
        let sorted = this.state.sectors
            .filter((sector) =>
                sector.accepted &&
                sector.name.toLowerCase().includes(this.state.sectorCreateInput.toLowerCase())
            )
            .sort((a, b) => {
                if (b.name.charAt(0) > a.name.charAt(0)) {
                    return -1;
                } else {
                    return 1;
                }
            });

        // Update noAcceptedDisplayed state based on results
        if (this.state.noAcceptedDisplayed !== (sorted.length === 0)) {
            // Only update if changed to avoid render loops
            setTimeout(() => {
                this.setState({ noAcceptedDisplayed: sorted.length === 0 });
            }, 0);
        }

        return sorted.map((sector, i) => (
            <button
                key={i}
                className="btn btn-light d-flex align-items-center"
                disabled
            >
                {sector.name}
            </button>
        ));
    };

    render() {
        const columns = [
            {
                name: "sectorId",
                label: "Sector ID",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => value ?? "-",
                },
            },
            {
                name: "name",
                label: "Name",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => value ?? "-",
                },
            },
            {
                name: "accepted",
                label: "Status",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        const sector = this.state.sectors[dataIndex];
                        const isLoading = this.state.updatingSectorIds.includes(sector.sectorId);

                        return (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <span style={{ color: sector.accepted ? "green" : "red", fontWeight: 500 }}>
                                    {sector.accepted ? "🟢 Active" : "🔴 Inactive"}
                                </span>
                                <Switch
                                    checked={sector.accepted}
                                    color="sucess"
                                    disabled={isLoading}
                                    onChange={() => this.updateSector(sector)}
                                    inputProps={{ "aria-label": "toggle active status" }}
                                />
                                {isLoading && (
                                    <div style={{ fontSize: "12px", color: "#888" }}>
                                        Updating...
                                    </div>
                                )}
                            </div>
                        );
                    },
                },
            },
        ];

        return (
            <div>
                <section>
                    <AccountBanner>
                        <h1 className="mb-4">Sectors</h1>
                        <p className="mb-0">Create sectors</p>
                    </AccountBanner>
                </section>

                <section className="gray-bg full-height">
                    <div className="container py-5">
                        <div className="input-group mb-3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="New Sector"
                                value={this.state.sectorCreateInput}
                                onChange={this.handleSectorInput}
                            />

                            <div className="input-group-append">
                                <ActionButton
                                    className="btn btn-primary"
                                    isDisabled={
                                        this.state.sectorCreateInput.length === 0 ||
                                        this.checkIfSectorExists(
                                            this.state.sectorCreateInput
                                        )
                                    }
                                    onClick={() =>
                                        this.addSector(this.state.sectorCreateInput)
                                    }
                                >
                                    Add Sector
                                </ActionButton>
                            </div>
                        </div>
                        <div>
                            <p style={{
                                color: "red", display: this.checkIfSectorExists(this.state.sectorCreateInput) ? "" : "none"
                            }}>{this.state.newSectorExists} <span style={{ color: "black" }}>- </span><span style={{ display: this.state.noAcceptedDisplayed ? "none" : "", color: "green" }}>currently ACTIVE</span><span style={{ display: this.state.noAcceptedDisplayed ? "" : "none", color: "red" }}>currently INACTIVE</span></p>
                        </div>
                        <div>
                            <h4 style={{
                                fontSize: "22px",
                                marginLeft: "15px",
                                marginBottom: 0,
                                fontWeight: 100
                            }}>Active Sectors</h4>
                        </div>
                        <div className="tag-content-sm d-flex justify-content flex-wrap py-3">
                            {this.displaySectors()}
                        </div>
                        <div>
                            <ThemeProvider theme={this.state.SectorsTable.getTheme()}>
                                <MUIDataTable
                                    title={
                                        <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                            <p
                                                style={{
                                                    fontSize: "22px",
                                                    marginTop: "20px",
                                                }}
                                            >
                                                All Sectors
                                            </p>
                                        </div>
                                    }
                                    data={this.state.sectors}
                                    columns={columns}
                                    options={{
                                        ...this.state.SectorsTable.options,
                                        textLabels: {
                                            body: {
                                                noMatch: this.state.sectorsLoading
                                                    ? "LOADING..."
                                                    : "No data available",
                                            },
                                        },
                                        selectableRows: "none",
                                        searchText: this.state.searchText,
                                        onSearchChange: (text) => {
                                            this.setState({ searchText: text });
                                        },
                                    }}
                                    ref={this.tableRef}
                                />
                            </ThemeProvider>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Sectors;
